// 使用政策管理
import http from "@/jslibs/axios/http";

// 使用政策更新
export const edit = (data) => http.post("/v1/cms/UsePolicy", data);

// 使用政策详情
export const detail = (data) => http.get("/v1/cms/UsePolicy", data);
